export default __webpack_public_path__ + "static/media/arrow-backward.b55a66cf.png";